export default __webpack_public_path__ + "static/media/olark.3adfcd96.svg";